import React, { useState } from 'react';
import { AUTHOR } from '@/config/authorProfile';

/**
 * Renders the author's photo if available; falls back to a clean initials
 * badge if the file isn't present (or in dev before the JPG is dropped).
 *
 * Usage: <AuthorAvatar size={64} />
 */
export default function AuthorAvatar({ size = 48, className = '' }) {
  const [broken, setBroken] = useState(false);
  const initials = AUTHOR.name
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const dim = { width: size, height: size };

  if (broken || !AUTHOR.photoUrl) {
    return (
      <span
        aria-label={AUTHOR.name}
        data-testid="author-avatar-initials"
        className={`inline-flex items-center justify-center rounded-full bg-slate-900 text-white font-semibold heading select-none flex-shrink-0 ${className}`}
        style={{ ...dim, fontSize: Math.round(size * 0.38) }}
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      src={AUTHOR.photoUrl}
      alt={AUTHOR.name}
      width={size}
      height={size}
      loading="lazy"
      onError={() => setBroken(true)}
      data-testid="author-avatar-photo"
      className={`rounded-full object-cover flex-shrink-0 ${className}`}
      style={dim}
    />
  );
}
